import { PropsWithChildren } from 'react';

const H6 = (props: PropsWithChildren<any>) => <h6 className={'ds-h6'} {...props}>{props.children}</h6>;

export default H6;